import React from 'react';
import { shape, bool } from 'prop-types';

const GlobeIcon = ({ colors, disabled }) => {
  const colorsDict = {
    iconColor: disabled ? '#D9D8DC' : '#fff',
    secondaryColor: disabled ? '#fff' : colors.brand.primary,
  };

  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill={colorsDict.secondaryColor} />
      <path
        d="M41.52 21C41.2634 19.9697 40.9119 18.9654 40.47 18C39.3109 15.4342 37.5327 13.1964 35.2951 11.4876C33.0575 9.77888 30.4305 8.65262 27.65 8.21C27.0656 8.0994 26.4741 8.02923 25.88 8C25.59 8 25.31 8 25.01 8C24.71 8 24.42 8 24.13 8C23.5366 8.01932 22.9452 8.07946 22.36 8.18C19.5747 8.62404 16.9436 9.75412 14.7039 11.4684C12.4641 13.1827 10.6861 15.4273 9.53002 18C9.10522 18.9672 8.77047 19.9714 8.53002 21C8.19946 22.3084 8.0216 23.6507 8.00002 25C7.99577 26.3468 8.15016 27.6894 8.46002 29C8.69558 30.03 9.03048 31.0347 9.46002 32C10.6162 34.5802 12.3977 36.8313 14.6432 38.5495C16.8887 40.2677 19.5273 41.3986 22.32 41.84C22.9057 41.9389 23.4967 42.0024 24.09 42.03L25 42H25.88C26.47 41.9724 27.0578 41.9089 27.64 41.81C30.4315 41.3731 33.0701 40.2474 35.3172 38.5346C37.5643 36.8218 39.349 34.5759 40.51 32C40.9396 31.0347 41.2745 30.03 41.51 29C41.83 27.6906 41.9945 26.348 42 25C41.9948 23.6526 41.8337 22.3104 41.52 21ZM37.08 18H31.66C31.6255 17.8802 31.5821 17.7632 31.53 17.65L29.06 11.65C32.4386 12.6792 35.3034 14.9475 37.08 18ZM29.5 29H20.5C19.83 26.3754 19.83 23.6246 20.5 21H29.5C30.1701 23.6246 30.1701 26.3754 29.5 29ZM25.56 39C25.1872 39.0267 24.8129 39.0267 24.44 39L21.55 32H28.45L25.56 39ZM24.43 11C24.8096 10.9733 25.1905 10.9733 25.57 11L28.42 18H21.58L24.43 11ZM20.94 11.6L18.47 17.6C18.418 17.7132 18.3745 17.8302 18.34 17.95H12.92C14.7005 14.905 17.5647 12.6443 20.94 11.62V11.6ZM11.38 28.26C11.1287 27.1915 11.0012 26.0976 11 25C10.9985 23.8818 11.1294 22.7674 11.39 21.68C11.45 21.43 11.53 21.19 11.61 20.95H17.43C16.8601 23.5862 16.8601 26.3138 17.43 28.95H11.58C11.51 28.72 11.44 28.49 11.38 28.26ZM12.86 32H18.32C18.32 32.12 18.41 32.24 18.46 32.36L21 38.4C17.5718 37.379 14.6612 35.0905 12.86 32ZM29.05 38.44L31.54 32.36C31.59 32.24 31.64 32.12 31.68 32H37.14C35.3543 35.0815 32.4613 37.3666 29.05 38.39V38.44ZM38.62 28.3C38.62 28.54 38.49 28.77 38.42 29H32.57C33.1399 26.3638 33.1399 23.6362 32.57 21H38.39C38.46 21.23 38.54 21.46 38.6 21.7C39.1199 23.8693 39.1199 26.1307 38.6 28.3H38.62Z"
        fill={colorsDict.iconColor}
      />
    </svg>
  );
};

GlobeIcon.propTypes = {
  colors: shape().isRequired,
  disabled: bool,
};

export default GlobeIcon;
